module.exports = __webpack_public_path__ + "img/typesense.ac8a9868.svg";